exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section[data-v-0f3a1c3f]{width:90%}#file-upload[data-v-0f3a1c3f]{background-color:inherit}#file-upload[disabled][data-v-0f3a1c3f]{background-color:#dee2e6dd}span[data-v-0f3a1c3f]{text-align:center}", ""]);

// exports
